;(function () {
  'use strict'

  angular
    .module('deskfy.core')
    .controller('FilterStatusDropdownController', filterStatusDropdownController)

  /* @ngInject */
  function filterStatusDropdownController ($scope, $attrs, $timeout) {
    const defaultStatusList = Array.from($scope.defaultStatusList)

    $scope.statusList = defaultStatusList
    $scope.statusSelected = []
    $scope.statusSelectedCache = []

    const api = {
      _handleToggleDropdown,
      _mergeStatusList,
      _checkStatusAlreadyExistsInArray,
      _checkEqualStatusId,
      _onHideDropdown
    }
    this.getApi = () => api

    activate()

    function activate () {
      const dropdownParams = {
        action: 'nothing',
        direction: 'downward',
        fullTextSearch: true,
        onHide: api._onHideDropdown
      }

      api._handleToggleDropdown(dropdownParams)
    }

    $scope.$watch('params.status', (newValue) => {
      $scope.statusSelected = [...newValue]
      if (newValue.length) {
        api._mergeStatusList($scope.statusSelected, $scope.statusList)
      } else {
        $scope.statusList = defaultStatusList
      }
    })

    $scope.handleSelect = (status) => {
      const index = $scope.statusSelected.findIndex(statusSelected => api._checkEqualStatusId(statusSelected, status))
      if (index !== -1) {
        $scope.statusSelected.splice(index, 1)
      } else {
        $scope.statusSelected = [status, ...$scope.statusSelected]
      }
    }

    $scope.isSelected = (status) => {
      const hasStatusSelected = $scope.statusSelected.find(statusSelected => api._checkEqualStatusId(statusSelected, status))

      if (hasStatusSelected) {
        return true
      }

      return false
    }

    $scope.handleRemove = (removeJustSelected) => {
      if (removeJustSelected) {
        $scope.statusSelectedCache = [...$scope.statusSelected]
        $scope.statusSelected = []
        return
      }

      $scope.params.status = []
      api._handleToggleDropdown('hide')
    }

    $scope.handleApply = () => {
      if ($scope.statusSelected.length) {
        $scope.params.status = $scope.statusSelected
      } else {
        $scope.params.status = []
      }

      api._handleToggleDropdown('hide')
      $scope.statusList = defaultStatusList
    }

    /**
     *  @param {object | string} options - config options for semantic dropdown
     *  @description this method open/close the dropdown menu, or initialize it
     */
    function _handleToggleDropdown (options) {
      $timeout(() => {
        $attrs.$$element.find('.ui.dropdown.filter-status-dropdown').dropdown(options)
      }, 100, false)
    }

    /**
     *  @typedef {Array} ArrayList
     *  @param {ArrayList} firstArray - items that will be first in the new array of status
     *  @param {ArrayList} lastArray - items that will be last in the new array of status
     *  @description this method merge two arrays and create a new array, only serve to merge the array of status
     */
    function _mergeStatusList (firstArray, lastArray) {
      const updatedList = lastArray.map(api._checkStatusAlreadyExistsInArray).filter(Boolean)
      $scope.statusList = [...firstArray, ...updatedList]
    }

    /**
     *  @param {object} status - object of status
     *  @description this method check if the status already exists in the array of status
     */
    function _checkStatusAlreadyExistsInArray (status) {
      const index = $scope.statusSelected.findIndex(selectedStatus => api._checkEqualStatusId(selectedStatus, status))
      if (index === -1) {
        return status
      }
    }

    /**
     *  @param {object} selectedStatus - object of status
     *  @param {object} status - object of selectedStatus
     *  @description this method checks if the selectedStatus is equal to the status
     */
    function _checkEqualStatusId (selectedStatus, status) {
      return selectedStatus.id === status.id
    }

    /**
     *  @description this method is called on hide the semantic dropdown
     */
    function _onHideDropdown () {
      if (!$scope.statusSelected.length && $scope.statusSelectedCache.length) {
        $scope.statusSelected = [...$scope.statusSelectedCache]
      }
    }
  }
})()
